// Tickable Mail: inbox, brand & sender, order and reservations (en)
export default {
  // Inbox
  "mail_inbox_intro": "When someone replies to a mail, it lands here, together with their order.",
  "mail_inbox_classic": "The inbox comes with the new mails. For now, replies go to your own e-mail address, if you've set one.",
  "mail_inbox_classic_link": "See what switching gets you",
  "mail_inbox_filter": "Which messages",
  "mail_inbox_filter_open": "Open",
  "mail_inbox_filter_done": "Done",
  "mail_inbox_filter_all": "All",
  "mail_inbox_empty": "No messages yet. Replies to your mails will show up here.",
  "mail_inbox_empty_open": "Nothing open. Nice work!",
  "mail_inbox_empty_done": "Nothing marked as done yet.",
  "mail_inbox_pick": "Pick a conversation on the left.",
  "mail_inbox_thread_gone": "This conversation doesn't exist (anymore).",
  "mail_inbox_unread": "Unread",
  "mail_inbox_just_now": "just now",
  "mail_inbox_no_subject": "(no subject)",
  "mail_inbox_message": "Message",
  "mail_inbox_no_messages": "There are no messages in this conversation yet.",
  "mail_inbox_you": "You",
  "mail_inbox_mark_done": "Mark as done",
  "mail_inbox_reopen": "Reopen",
  "mail_inbox_status_failed": "That didn't work",
  "mail_inbox_order": "order",
  "mail_inbox_order_of": "Order by {name}",
  "mail_inbox_order_unpaid": "not paid yet",
  "mail_inbox_ticket_count": "{count} ticket | {count} tickets",
  "mail_inbox_resend_tickets": "Resend tickets",
  "mail_inbox_contact_consent": "Contact, agreed to receive news",
  "mail_inbox_contact_no_consent": "Contact, no consent for news",
  "mail_inbox_attachment_not_stored": "attachment not stored",
  "mail_inbox_reply_to": "Reply to {email}",
  "mail_inbox_reply_hint": "Ctrl + Enter sends too",
  "mail_inbox_send": "Send",
  "mail_inbox_send_failed": "Your reply wasn't sent",
  "mail_inbox_send_failed_detail": "Your text is still there. Try again in a moment.",
  "mail_inbox_no_write_right": "You can read this conversation, but not reply. Ask the owner of your organization for the 'Edit e-mail' right.",

  // Brand & sender
  "mail_settings_intro_on": "What your mails look like, who they're from and what visitors tick in your shop.",
  "mail_settings_intro_classic": "Your mails still go out the classic way. You can already collect consent in your shop, so you'll have a list later.",
  "mail_settings_read_only": "You can view these settings, but not change them.",
  "mail_settings_save": "Save",
  "mail_settings_save_failed": "Saving didn't work",
  "mail_settings_unsaved": "You have changes that aren't saved yet. Leave anyway?",
  "mail_settings_consent_title": "Consent in your shop",
  "mail_settings_consent_description": "Buyers can say at checkout that they'd like news from you. The box is never ticked in advance.",
  "mail_settings_consent_toggle": "Ask for consent at checkout",
  "mail_settings_consent_label": "Text next to the box",
  "mail_settings_consent_default": "Keep me posted about new events from {name}",
  "mail_settings_consent_label_help": "Leave it empty to use the text above.",
  "mail_settings_consent_label_needs_name": "Put your name ({name}) in the text, so buyers know who they'll get mail from.",
  "mail_settings_consent_preview": "This is how it looks in your shop",
  "mail_settings_languages_title": "Languages",
  "mail_settings_languages_description": "The languages your mails (and later your shop) come in. Buyers get their mail in the language they ordered in.",
  "mail_settings_languages": "Languages",
  "mail_settings_source_language": "Source language",
  "mail_settings_source_language_help": "You write in this one. When a translation is missing, buyers get this language.",
  "mail_settings_sender_title": "Sender",
  "mail_settings_sender_description": "Who your mails come from and where replies go.",
  "mail_settings_sender_name": "Sender name",
  "mail_settings_sender_preview": "Your mails come from {address}. Replies land in your inbox.",
  "mail_settings_postal_address": "Postal address",
  "mail_settings_postal_address_help": "By law, a newsletter needs the sender's postal address. Without one you can't send campaigns.",
  "mail_settings_attach_pdf": "Also attach the tickets as a PDF",
  "mail_settings_attach_pdf_help": "Usually not needed: every mail has a button to the order page with all tickets, and mails without attachments arrive more reliably. Turn it on if visitors are scanned somewhere without signal.",
  "mail_settings_brand_title": "Brand",
  "mail_settings_consent_label_add": "Change the text",
  "mail_settings_sender_name_add": "Change the sender name",
  "mail_settings_postal_address_add": "Add a postal address",
  "mail_settings_attach_pdf_add": "Attach tickets as PDF",
  "mail_settings_brand_add": "Own style for mails",
  "mail_settings_logo_dark_add": "Logo for dark mode",
  "mail_settings_font_add": "Font",
  "mail_settings_brand_description": "Your logo, colours and font in every mail. Without your own choice we use the activity's theme, otherwise your shop's.",
  "mail_settings_logo": "Logo",
  "mail_settings_logo_upload": "Upload logo",
  "mail_settings_logo_advice": "A PNG with a transparent background works best. Max 1 MB.",
  "mail_settings_logo_dark": "Logo for dark mode (optional)",
  "mail_settings_logo_dark_advice": "A light version, for mail apps in dark mode.",
  "mail_settings_logo_background": "Put the logo on its own background",
  "mail_settings_accent": "Accent colour",
  "mail_settings_background": "Background",
  "mail_settings_card_color": "Blocks",
  "mail_settings_text_color": "Text colour",
  "mail_settings_font": "Font",
  "mail_settings_brand_from_shop": "Copy from your shop",
  "mail_settings_domain_title": "Mail from your own domain",
  "mail_settings_domain_offer": "Mail from tickets{'@'}yourfestival.com",
  "mail_settings_domain_explain": "Your mailbox keeps working as it is: you only add a few DNS records. We'll build this once enough organizers want it.",
  "mail_settings_domain_interest": "I'm interested",
  "mail_settings_domain_noted": "We'll get in touch. You let us know on {date}.",
  "mail_settings_quota": "On the free plan you can mail up to {limit} contacts with consent. You have {count} now.",
  "mail_settings_classic_description": "Your ticket mails go back to the fixed layout. Nothing is deleted: your templates, automations and inbox are still there when you come back.",
  "mail_settings_classic_button": "Back to classic",
  "mail_settings_classic_confirm_title": "Back to classic?",
  "mail_settings_classic_confirm": "Automations and campaigns stop, and your ticket mails get the fixed layout again. You can switch back any time.",

  // Order
  "mail_order_mail": "Mail",
  "mail_order_resent": "Tickets are on their way",
  "mail_order_resent_to": "We're sending them to {email} again.",
  "mail_order_resend_failed": "Resending didn't work",
  "mail_order_resend_failed_detail": "Try again in a moment. Still going wrong? Let us know.",

  // Reservations
  "mail_reservation_event": "Event",
  "mail_reservation_timeslot": "Timeslot",
  "mail_reservation_pick_timeslot": "Pick a timeslot",
  "mail_reservation_tickets": "Tickets",
  "mail_reservation_no_ticket_types": "There are no ticket types for this event or timeslot.",
  "mail_reservation_total": "{count} ticket | {count} tickets",
  "mail_reservation_name": "Name",
  "mail_reservation_email": "E-mail address",
  "mail_reservation_email_invalid": "Enter a valid e-mail address, the payment link goes there.",
  "mail_reservation_language": "Language of the mail",
  "mail_reservation_deadline": "Pay within",
  "mail_reservation_days": "{count} day | {count} days",
  "mail_reservation_deadline_until": "Until {date}",
  "mail_reservation_need_timeslot": "Pick a timeslot.",
  "mail_reservation_need_tickets": "Pick at least one ticket.",
  "mail_reservation_cancel": "Cancel",
  "mail_reservation_done": "Reservation made, the payment link is on its way to {email}.",
  "mail_reservation_link": "Payment link",
  "mail_reservation_link_help": "You can also send it yourself. It works until {date}.",
  "mail_reservation_open_order": "View order",
  "mail_reservation_close": "Close",
}
